<template>
  <div class="report-ve-awards">
    <PreContentHeader :show-loading="!contentReady" :error-message="contentLoadError"></PreContentHeader>
    <transition name="fade">
      <div v-if="contentReady && contentLoadError === ''">
        <ContentHeader :name="$route.name"></ContentHeader>
        <div class="alert alert-info">
          <button type="button" class="btn btn-primary float-right showHideBtn" v-b-toggle.filterControls v-on:click="showHideFilters()" title="Show/Hide Filters" v-b-tooltip.hover>
            <span v-html="showHideFilterText"></span>
          </button>
          <div class="mr-2 float-right">
            Download current view as:
            <button type="button" class="btn btn-link p-0" v-on:click="exportFullReportToCSV()">
              <i class="fas fa-file-excel fa-2x" v-b-tooltip.hover title="Download All records as a CSV file"></i>
            </button>
            <button type="button" class="btn btn-link p-0" v-on:click="exportToCSV()">
              <i class="fas fa-file-excel fa-2x" v-b-tooltip.hover title="Download as a CSV file"></i>
            </button>
            <button type="button" class="btn btn-link p-0" v-on:click="exportToPDF()">
              <i class="fas fa-file-pdf fa-fw fa-2x" title="Download as a PDF document" v-b-tooltip.hover></i>
            </button>
          </div>
          <h4 class="alert-heading">Filtered Search</h4>
          <b-collapse visible id="filterControls" accordion="link-accordion" role="tabpanel">
            <hr>
            <div class="row">
              <div class="col-sm-4 mb-2">
                <label>Nomination Category</label>
                <select v-model="nominationCategorySelect" v-on:change="loadNominations()" class="form-control">
                  <option>-- All --</option>
                  <option v-for="category in nominationCategories" v-bind:key="category.id" :value="category.id">{{category.name}}</option>
                </select>
              </div>
              <div class="col-sm-4 mb-2">
                <label>Community</label>
                <select v-model="communityCategorySelect" v-on:change="loadNominations()" class="form-control">
                  <option>-- All --</option>
                  <option v-for="category in communityCategories" v-bind:key="category.id" :value="category.id">{{category.name}}</option>
                </select>
              </div>
              <div class="col-sm-4 mb-2">
                <label class="d-none d-xl-block">&nbsp;</label>
                <div class="form-check form-control pl-5">
                  <input class="form-check-input" type="checkbox" v-model="graduatedNominationsCheck" id="graduatedNominationsCheck" v-on:change="filterByGraduatedNominations()">
                  <label class="form-check-label" for="graduatedNominationsCheck"><i class="fas fa-star fa-fw" style="color: darkgoldenrod"></i> Graduated nominations</label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-3 mb-2">
                <label for="nominatorFilter">From Date:</label>
                <div class="input-group">
                  <input type="date" ref="fromDate" name="fromDate" id="fromDate" :value="fromDate" v-on:change="loadNominations()" />
                  <!-- <input type="text" id="nominatorFilter" v-model="nominatorFilter" v-on:keyup.enter="filterByNominator()" class="form-control" placeholder="Enter name...">
                  <div class="input-group-append">
                    <button v-on:click="filterByNominator()" type="submit" id="searchsubmit" class="btn btn-primary">{{nominatorFilterButton}}</button>
                  </div> -->
                </div>
              </div>
              <div class="col-sm-3 mb-2">
                <label for="nomineeFilter">To Date:</label>
                <input type="date" ref="toDate" name="toDate" id="toDate" :value="toDate" v-on:change="loadNominations()" />
                <!-- <div class="input-group">
                  <input id="nomineeFilter" type="text" v-model="nomineeFilter" v-on:keyup.enter="filterByNominee()" class="form-control" placeholder="Enter name...">
                  <div class="input-group-append">
                    <button v-on:click="filterByNominee()" type="submit" id="searchsubmit" class="btn btn-primary">{{nomineeFilterButton}}</button>
                  </div>
                </div> -->
              </div>
              <div class="col-sm-6 mb-2">
                <label>Status</label><br>
                <div class="d-flex">
                  <div class="mr-2">
                    <input checked type="radio" name="status" value="All" id="all" v-on:click="filterByStatus('All')"> <label for="all">All</label>
                  </div>
                  <div class="mr-2">
                    <input type="radio" name="status" value="Pending" id="pending" v-on:click="filterByStatus('Pending')"> <label for="pending">Pending</label>
                  </div>
                  <div class="mr-2">
                    <input type="radio" name="status" value="Accepted" id="accepted" v-on:click="filterByStatus('Accepted')"> <label for="accepted">Accepted</label>
                  </div>
                  <div>
                    <input type="radio" name="status" value="Declined" id="declined" v-on:click="filterByStatus('Declined')"> <label for="declined">Declined</label>
                  </div>
                </div>
              </div>
            </div>
          </b-collapse>
        </div>
        <div class="row" id="nominations">
          <div class="col-sm-3">
            <div class="alert alert-primary text-center" role="alert">
              Nominations: {{nominationCounts.total}}
            </div>
          </div>
          <div class="col-sm-3">
            <div class="alert alert-warning text-center" role="alert">
              Pending: {{nominationCounts.pending}}
            </div>
          </div>
          <div class="col-sm-3">
            <div class="alert alert-success text-center" role="alert">
              Accepted: {{nominationCounts.accepted}}
            </div>
          </div>
          <div class="col-sm-3">
            <div class="alert alert-danger text-center" role="alert">
              Declined: {{nominationCounts.declined}}
            </div>
          </div>
        </div>
        <NominationReportEntries v-if="nominations.length > 0" :nominations="nominations"></NominationReportEntries>
        <span v-if="nominations.length === 0">
          No nominations have been submitted
        </span>
        <div class="row">
          <div class="col-sm-6 mt-3">
            <b-pagination size="md" :total-rows="totalPosts" v-model="currentPage" :per-page="itemsPerPage"></b-pagination>
          </div>
          <div class="col-sm-6 mt-3">
            <div class="items-per-page">
              <label for="itemsPerPage">Items per page: </label>
              <select v-model="itemsPerPage" id="itemsPerPage" v-on:change="loadNominations()" class="form-control">
                <option :value="10">10</option>
                <option :value="25">25</option>
                <option :value="50">50</option>
                <option :value="100">100</option>
                <option :value="500">500</option>
                <option :value="1000">1000</option>
                <option :value="2000">2000</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <iframe id="iFramePdf" src="myPdfUrl.pdf" style="display:none;"></iframe>
  </div>
</template>

<script>
import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
import ExportToCSV from '@/helpers/ExportToCSV.js'
import ContentHeader from '@/components/ContentHeader'
import NominationReportEntries from '@/components/NominationReportEntries'
import PreContentHeader from '@/components/PreContentHeader'

export default {
  components: {
    PreContentHeader,
    ContentHeader,
    NominationReportEntries
  },
  data () {
    return {
      nominations: [],
      totalNominations: [],
      unfilteredNominations: [],
      contentReady: false,
      contentLoadError: '',
      graduatedNominationsCheck: false,
      nominationCategories: [],
      nominationCategorySelect: '-- All --',
      communityCategories: [],
      communityCategorySelect: '-- All --',
      nominatorFilter: '',
      nominatorFilterButton: '+',
      nomineeFilter: '',
      nomineeFilterButton: '+',
      showHideFilterText: '<i class="fas fa-angle-up"></i>',
      currentPage: 1,
      totalPosts: 0,
      itemsPerPage: 10,
      toDate: '',
      fromDate: ''
    }
  },
  computed: {
    nominationCounts: function () {
      return {
        total: this.totalPosts,
        pending: this.nominations.filter(x => x.nomination_approve_decline[0] === 'Pending').length,
        accepted: this.nominations.filter(x => x.nomination_approve_decline[0] === 'Accepted').length,
        declined: this.nominations.filter(x => x.nomination_approve_decline[0] === 'Declined').length
      }
    }
  },
  created () {
    document.title = this.$route.name + ' - ThinkTank'
    WordpressRestAPI.getViewContent('nomination_event_category?per_page=100&parent=20')
      .then(response => {
        this.nominationCategories = response.data.filter(x => x.id !== 22 && x.id !== 35 && x.id !== 21)
      })
      .catch(e => {
        console.error(e)
      })
    WordpressRestAPI.getViewContent('community_categories?per_page=100')
      .then(response => {
        this.communityCategories = response.data
      })
      .catch(e => {
        console.error(e)
      })
    this.loadNominations()
  },
  methods: {
    exportToPDF: function () {
      window.print()
    },
    validateDates: function() {
      if (this.$refs.toDate)
        this.toDate = this.$refs.toDate.value

      if (this.$refs.fromDate)
        this.fromDate = this.$refs.fromDate.value


      if ( this.toDate !== '' && this.fromDate !== '' ) {
        console.log('nomination date-> ', this.nominations[0].date)
        console.log('nomination parse date-> ', Date.parse(this.nominations[0].date))
        return '&after=' + this.fromDate + ' 00:00:00&before=' + this.toDate + ' 23:59:59'
      }
      return ''
    },
    exportContentData: function (data) {
      var chunks = data[0].split(' @#$% ')
      var header = ''
      var value = ''
      var exportData = []
      chunks.map(function (val, index) {
        if (val.indexOf('<h>') > -1) {
          header = val.replace(/<h>/g, '').replace(/<strong>/g, '').replace(/<\/strong>/g, '').replace(/<p>/g, '').replace(/<\/p>/g, '').replace(/<ul>/g, '').replace(/<\/ul>/g, '').replace(/<li>/g, '').replace(/<\/li>/g, '').replace(/<br>/g, ' ').replace(/<br\/>/g, ' ').replace(/,/g, ';')
        }
        if (val.indexOf('<c>') > -1) {
          value = val.replace(/<c>/g, '').replace(/<strong>/g, '').replace(/<\/strong>/g, '').replace(/<p>/g, '').replace(/<\/p>/g, '').replace(/<ul>/g, '').replace(/<\/ul>/g, '').replace(/<li>/g, '').replace(/<\/li>/g, '').replace(/<br>/g, ' ').replace(/<br\/>/g, ' ').replace(/,/g, ';').replace(/�/g, '\'').replace(/�/g, '"').replace(/�/g, '"')
          exportData[header] = value
        }
      })
      return exportData
    },
    getSingleNomineeInfo: function (x) {
      var nomineesInfo = { 'nomineeName': [], 'nomineeEmployeNumber': [], 'nomineeEmail': [], 'nomineeCompany': [], 'businessUnit': [], 'country': [], 'gom': [], 'projectSponsor': 'NA', 'projectSponsorApproved': 'NA', 'projectSponsorDeclinedReason': 'NA', 'projectSponsorDate': 'NA' }
      nomineesInfo.nomineeName = x.nominee_name[0]
      nomineesInfo.nomineeEmployeNumber = x.nominee_employeeNumber[0]
      nomineesInfo.nomineeEmail = x.nominee_slug[0].replace(/multichoice/g, '@multichoice').replace(/-/g, '.')
      nomineesInfo.nomineeCompany = (x.nominee_company.length) ? x.nominee_company[0].replace(/,/g, ' ') : ''
      nomineesInfo.businessUnit = ' '
      nomineesInfo.country = ' '
      nomineesInfo.gom = ' '
      if ('employeehierarchy' in x.nominee_slug && x.nominee_slug.employeehierarchy) {
        nomineesInfo.nomineeEmail = x.nominee_slug[1]
        nomineesInfo.businessUnit = 'businessunit' in x.nominee_slug.employeehierarchy ? x.nominee_slug.employeehierarchy.businessunit[0] : ''
        nomineesInfo.country = x.nominee_slug.employeehierarchy.country[0]
        nomineesInfo.gom = x.nominee_slug.employeehierarchy.gom[0]
        if ('employeenumber' in x.nominee_slug.employeehierarchy)
          nomineesInfo.nomineeEmployeNumber = x.nominee_slug.employeehierarchy.employeenumber[0]
      }
      return nomineesInfo
    },
    getNomineeInfo: function (nomineesInfo, x, i, count) {
      nomineesInfo.nomineeName += (count - 1 === i) ? x.member_name : x.member_name + ' $&$ '
      var nomineeEmployeNumber = (count - 1 === i) ? x.member_employee_number : x.member_employee_number + ' $&$ '
      nomineesInfo.nomineeCompany += (count - 1 === i) ? x.member_company.replace(/,/g, ' ') : x.member_company.replace(/,/g, ' ') + ' $&$ '
      var employeeNumberflag = true
      if (x.member_email.indexOf('@') > -1 && 'businessunit' in x.employeehierarchy) {
        nomineesInfo.nomineeEmail += (count - 1 === i) ? x.member_email : x.member_email + ' $&$ '
        nomineesInfo.businessUnit += (count - 1 === i) ? x.employeehierarchy.businessunit[0] : x.employeehierarchy.businessunit[0] + ' $&$ '
        nomineesInfo.country += (count - 1 === i) ? x.employeehierarchy.country[0] : x.employeehierarchy.country[0] + ' $&$ '
        nomineesInfo.gom += (count - 1 === i) ? x.employeehierarchy.gom[0] : x.employeehierarchy.gom[0] + ' $&$ '
        if ('employeenumber' in x.employeehierarchy) {
          employeeNumberflag = false
          nomineesInfo.nomineeEmployeNumber += (count - 1 === i) ? x.employeehierarchy.employeenumber[0] : x.employeehierarchy.employeenumber[0] + ' $&$ '
        }
      }
      else {
        nomineesInfo.gom = nomineesInfo.nomineeCompany
        nomineesInfo.businessUnit += (count - 1 === i) ? ' '  : '  $&$ '
        nomineesInfo.country += (count - 1 === i) ? ' '  : '  $&$ '
        var emailCreator = ''
        var emailCreatorName = ''
        emailCreator = x.member_name.replace(/ /g, '.') + '@'
        emailCreatorName = x.member_name.toLowerCase().replace(/ /g, '-')
        emailCreator = x.member_slug.replace(emailCreatorName, emailCreator).replace(/-/g, '.')
        if (x.member_company.toLowerCase().indexOf('multichoice') > -1) {
          nomineesInfo.nomineeEmail += (count - 1 === i) ? emailCreator : emailCreator + ' $&$ '
        } else {
          nomineesInfo.nomineeEmail += (count - 1 === i) ? x.member_slug.replace(/multichoice/g, '@multichoice').replace(/-/g, '.') : x.member_slug.replace(/multichoice/g, '@multichoice').replace(/-/g, '.') + ' $&$ '
        }
      }
      if (employeeNumberflag == true)
        nomineesInfo.nomineeEmployeNumber += nomineeEmployeNumber
      return nomineesInfo
    },
    exportTeamData: function (teamDetails) {
      var self = this
      var nomineesInfo = {'nomineeName': [], 'nomineeEmployeNumber': [], 'nomineeEmail': [], 'nomineeCompany': [], 'businessUnit': [], 'country': [], 'gom': []}
      var count = teamDetails.length
      if (count > 1) {
        teamDetails.map(function (x, i) {
          nomineesInfo = self.getNomineeInfo(nomineesInfo, x, i, count)
        })
      } else {
        teamDetails[0].map(function (x, i) {
          nomineesInfo = self.getNomineeInfo(nomineesInfo, x, i, count)
        })
      }
      return nomineesInfo
    },
    getDateTime: function (val, needle, index) {
      if(val !== undefined && val !== null && val !== "" && val !== "NA") {
        return val.split(needle)[index]
      } else {
        return 'NA'
      }
    },
    exportToCSV: function () {
      var self = this
      // Map fields of nominations array that will be converted to CSV
      const items = this.nominations.map(function (x) {
        var splitData = {}
        var nomineesDetails = {}
        if (x.nomination_event_category[0] !== 19 && x.nomination_event_category[0] !== 18 && x.nomination_event_category[0] !== 17) {
          do {
            if (x.teamnominationworkflow[0].length === 1) {
              console.log('moved ->  ')
              x.teamnominationworkflow[0] = x.teamnominationworkflow[0][0]
            }
          } while (x.teamnominationworkflow[0].length === 1)
        }
        if (x.nominationdata.length) {
          splitData = self.exportContentData(x.nominationdata)
        }
        if (x.isteamaward[0] === 'true' || x.nominationteam[0]) {
          nomineesDetails = self.exportTeamData(x.nominationteam[0])
          if (x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Sponsor')).length > 0) {
            nomineesDetails.projectSponsor = (x.teamnominationworkflow.length) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Sponsor'))[0]['project_sponsor_email'] : ''
            nomineesDetails.projectSponsorApproved = (x.teamnominationworkflow.length) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Sponsor'))[0]['project_sponsor_status'] : ''
            nomineesDetails.projectSponsorDeclinedReason = (x.teamnominationworkflow.length) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Sponsor'))[0]['project_sponsor_comment'] : ''
            nomineesDetails.projectSponsorDate = (x.teamnominationworkflow.length) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Sponsor'))[0]['project_sponsor_datetime'] : ''
          }
        } else {
          nomineesDetails = self.getSingleNomineeInfo(x)
        }
        const temp = Object.assign({}, {
          Nominator_Name: x._embedded.author[0].name,
          Nominator_Employee_Number: x.nominator_details[0][0]['employee-number'],
          Nominee_Name: nomineesDetails.nomineeName,
          Nominee_Employee_Number: nomineesDetails.nomineeEmployeNumber,
          Nominee_Email: nomineesDetails.nomineeEmail,
          GOM: nomineesDetails.gom,
          BU: nomineesDetails.businessUnit,
          Country: nomineesDetails.country,
          Award_Category: (x._embedded['wp:term'][1].length) ? x._embedded['wp:term'][1][0].name : x.title.rendered,
          Nominee_Status: x.nomination_approve_decline[0],
          Date_Of_Nomination: x.date.split('T')[0],
          Time_Of_Nomination: x.date.split('T')[1],
          Project_Sponsor: nomineesDetails.projectSponsor,
          Project_Sponsor_Approved: nomineesDetails.projectSponsorApproved,
          Project_Sponsor_Reason: nomineesDetails.projectSponsorDeclinedReason,
          Project_Sponsor_Date: self.getDateTime(nomineesDetails.projectSponsorDate, ' ', 0),
          Project_Sponsor_Time: self.getDateTime(nomineesDetails.projectSponsorDate, ' ', 1),
          Line_Manager: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Manager'))[0]['project_sponsor_email'] : '',
          Line_Manager_Approved: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Manager'))[0]['project_sponsor_status'] : '',
          Line_Manager_Reason: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Manager'))[0]['project_sponsor_comment'] : '',
          Line_Manager_Date: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? self.getDateTime(x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Manager'))[0]['project_sponsor_datetime'], ' ', 0) : 'NA',
          Line_Manager_Time: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? self.getDateTime(x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Manager'))[0]['project_sponsor_datetime'], ' ', 1) : 'NA',
          Exco2: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Exco2'))[0]['project_sponsor_email'] : '',
          Exco2_Approved: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Exco2'))[0]['project_sponsor_status'] : '',
          Exco2_Reason: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Exco2'))[0]['project_sponsor_comment'] : '',
          Exco2_Date: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? self.getDateTime(x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Exco2'))[0]['project_sponsor_datetime'], ' ', 0) : 'NA',
          Exco2_Time: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? self.getDateTime(x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Exco2'))[0]['project_sponsor_datetime'], ' ', 1) : 'NA',
          HRBP: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'HRBP'))[0]['project_sponsor_email'] : '',
          HRBP_Approved: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'HRBP'))[0]['project_sponsor_status'] : 'NA',
          HRBP_Reason: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'HRBP'))[0]['project_sponsor_comment'] : 'NA',
          HRBP_Date: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? self.getDateTime(x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'HRBP'))[0]['project_sponsor_datetime'], ' ', 0) : 'NA',
          HRBP_Time: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? self.getDateTime(x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'HRBP'))[0]['project_sponsor_datetime'], ' ', 1) : 'NA'
        }, splitData)
        return temp
      })

      var keysOnly = []
      for (var k = 0; k < items.length; k++) {
        keysOnly = keysOnly.concat(Object.keys(items[k]))
      }

      let csvKeys = keysOnly.filter((v, i) => keysOnly.indexOf(v) === i)

      for (var i = 0; i < items.length; i++) {
        for (var j = 0; j < csvKeys.length; j++) {
          if (items[i][csvKeys[j]]) {
            items[i][csvKeys[j]] = items[i][csvKeys[j]]
          } else {
            items[i][csvKeys[j]] = ''
          }
        }
      }

      // Convert to JSON and then create CSV file for download
      let cloneItems = []
      let dupItems = JSON.parse(JSON.stringify(items))
      var iIndex = 0
      for (var u = 0; u < dupItems.length; u++) {
        if (dupItems[u].Nominee_Name.includes(' $&$ ')) {
          var nomineeNameCount = dupItems[u].Nominee_Name.split(' $&$ ')
          var nomineeEmployeNumberCount = dupItems[u].Nominee_Employee_Number.split(' $&$ ')
          var nomineeEmailCount = dupItems[u].Nominee_Email.split(' $&$ ')
          var nomineeCompanyCount = dupItems[u].GOM.split(' $&$ ')
          for (var w = 0; w < nomineeNameCount.length; w++) {
            cloneItems[iIndex] = JSON.parse(JSON.stringify(dupItems[u]))
            cloneItems[iIndex].Nominee_Name = nomineeNameCount[w]
            cloneItems[iIndex].Nominee_Employee_Number = nomineeEmployeNumberCount[w]
            cloneItems[iIndex].Nominee_Email = nomineeEmailCount[w]
            cloneItems[iIndex].GOM = nomineeCompanyCount[w]
            iIndex++
          }
        } else {
          cloneItems[iIndex] = JSON.parse(JSON.stringify(dupItems[u]))
          iIndex++
        }
      }
      console.log('items', items)
      ExportToCSV.createCSV(items, 'Recognition', 'Nominee_Name', ['Date_Of_Nomination', 'Project_Sponsor', 'Project_Sponsor_Approved', 'Project_Sponsor_Reason', 'Project_Sponsor_Date', 'Project_Sponsor_Time', 'Line_Manager', 'Line_Manager_Approved', 'Line_Manager_Reason', 'Line_Manager_Date', 'Line_Manager_Time', 'Exco2', 'Exco2_Approved', 'Exco2_Reason', 'Exco2_Date', 'Exco2_Time', 'HRBP', 'HRBP_Approved', 'HRBP_Reason', 'HRBP_Date', 'HRBP_Time'])
      // ExportToCSV.createCSV(Object.values(cloneItems), 'VE_Awards_Nominations')
    },
    exportFullReportToCSV: function () {
    
      this.totalLoadNominations()
      .then(() => {
      var self = this
      // Map fields of totalNominations array that will be converted to CSV
      const items = this.totalNominations.map(function (x) {
        console.log(' x ', x, x.id)
        var splitData = {}
        var nomineesDetails = {}
        if (x.nomination_event_category[0] !== 19 && x.nomination_event_category[0] !== 18 && x.nomination_event_category[0] !== 17) {
          do {
            if (x.teamnominationworkflow[0].length === 1) {
              console.log('moved ->  ')
              x.teamnominationworkflow[0] = x.teamnominationworkflow[0][0]
            }
          } while (x.teamnominationworkflow[0].length === 1)
        }
        if (x.nominationdata.length) {
          splitData = self.exportContentData(x.nominationdata)
        }
        if (x.isteamaward[0] === 'true' || x.nominationteam[0]) {
          nomineesDetails = self.exportTeamData(x.nominationteam[0])
          if (x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Sponsor')).length > 0) {
            nomineesDetails.projectSponsor = (x.teamnominationworkflow.length) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Sponsor'))[0]['project_sponsor_email'] : ''
            nomineesDetails.projectSponsorApproved = (x.teamnominationworkflow.length) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Sponsor'))[0]['project_sponsor_status'] : ''
            nomineesDetails.projectSponsorDeclinedReason = (x.teamnominationworkflow.length) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Sponsor'))[0]['project_sponsor_comment'] : ''
            nomineesDetails.projectSponsorDate = (x.teamnominationworkflow.length) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Sponsor'))[0]['project_sponsor_datetime'] : ''
          }
        } else {
          nomineesDetails = self.getSingleNomineeInfo(x)
        }
        const temp = Object.assign({}, {
          Nominator_Name: x._embedded.author[0].name,
          Nominator_Employee_Number: x.nominator_details[0][0]['employee-number'],
          Nominee_Name: nomineesDetails.nomineeName,
          Nominee_Employee_Number: nomineesDetails.nomineeEmployeNumber,
          Nominee_Email: nomineesDetails.nomineeEmail,
          GOM: nomineesDetails.gom,
          BU: nomineesDetails.businessUnit,
          Country: nomineesDetails.country,
          Award_Category: (x._embedded['wp:term'][1].length) ? x._embedded['wp:term'][1][0].name : x.title.rendered,
          Nominee_Status: x.nomination_approve_decline[0],
          Date_Of_Nomination: x.date.split('T')[0],
          Time_Of_Nomination: x.date.split('T')[1],
          Project_Sponsor: nomineesDetails.projectSponsor,
          Project_Sponsor_Approved: nomineesDetails.projectSponsorApproved,
          Project_Sponsor_Reason: nomineesDetails.projectSponsorDeclinedReason,
          Project_Sponsor_Date: self.getDateTime(nomineesDetails.projectSponsorDate, ' ', 0),
          Project_Sponsor_Time: self.getDateTime(nomineesDetails.projectSponsorDate, ' ', 1),
          Line_Manager: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Manager'))[0]['project_sponsor_email'] : '',
          Line_Manager_Approved: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Manager'))[0]['project_sponsor_status'] : '',
          Line_Manager_Reason: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Manager'))[0]['project_sponsor_comment'] : '',
          Line_Manager_Date: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? self.getDateTime(x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Manager'))[0]['project_sponsor_datetime'], ' ', 0) : 'NA',
          Line_Manager_Time: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? self.getDateTime(x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Manager'))[0]['project_sponsor_datetime'], ' ', 1) : 'NA',
          Exco2: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Exco2'))[0]['project_sponsor_email'] : '',
          Exco2_Approved: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Exco2'))[0]['project_sponsor_status'] : '',
          Exco2_Reason: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Exco2'))[0]['project_sponsor_comment'] : '',
          Exco2_Date: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? self.getDateTime(x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Exco2'))[0]['project_sponsor_datetime'], ' ', 0) : 'NA',
          Exco2_Time: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? self.getDateTime(x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Exco2'))[0]['project_sponsor_datetime'], ' ', 1) : 'NA',
          HRBP: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'HRBP'))[0]['project_sponsor_email'] : '',
          HRBP_Approved: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'HRBP'))[0]['project_sponsor_status'] : 'NA',
          HRBP_Reason: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'HRBP'))[0]['project_sponsor_comment'] : 'NA',
          HRBP_Date: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? self.getDateTime(x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'HRBP'))[0]['project_sponsor_datetime'], ' ', 0) : 'NA',
          HRBP_Time: (x.teamnominationworkflow.length && x.teamnominationworkflow[0] !== null) ? self.getDateTime(x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'HRBP'))[0]['project_sponsor_datetime'], ' ', 1) : 'NA'
        }, splitData)
        return temp
      })

      var keysOnly = []
      for (var k = 0; k < items.length; k++) {
        keysOnly = keysOnly.concat(Object.keys(items[k]))
      }

      let csvKeys = keysOnly.filter((v, i) => keysOnly.indexOf(v) === i)

      for (var i = 0; i < items.length; i++) {
        for (var j = 0; j < csvKeys.length; j++) {
          if (items[i][csvKeys[j]]) {
            items[i][csvKeys[j]] = items[i][csvKeys[j]]
          } else {
            items[i][csvKeys[j]] = ''
          }
        }
      }

      // Convert to JSON and then create CSV file for download
      let cloneItems = []
      let dupItems = JSON.parse(JSON.stringify(items))
      var iIndex = 0
      for (var u = 0; u < dupItems.length; u++) {
        if (dupItems[u].Nominee_Name.includes(' $&$ ')) {
          var nomineeNameCount = dupItems[u].Nominee_Name.split(' $&$ ')
          var nomineeEmployeNumberCount = dupItems[u].Nominee_Employee_Number.split(' $&$ ')
          var nomineeEmailCount = dupItems[u].Nominee_Email.split(' $&$ ')
          var nomineeCompanyCount = dupItems[u].GOM.split(' $&$ ')
          for (var w = 0; w < nomineeNameCount.length; w++) {
            cloneItems[iIndex] = JSON.parse(JSON.stringify(dupItems[u]))
            cloneItems[iIndex].Nominee_Name = nomineeNameCount[w]
            cloneItems[iIndex].Nominee_Employee_Number = nomineeEmployeNumberCount[w]
            cloneItems[iIndex].Nominee_Email = nomineeEmailCount[w]
            cloneItems[iIndex].GOM = nomineeCompanyCount[w]
            iIndex++
          }
        } else {
          cloneItems[iIndex] = JSON.parse(JSON.stringify(dupItems[u]))
          iIndex++
        }
      }
      console.log('items', items)
      ExportToCSV.createCSV(items, 'Recognition', 'Nominee_Name', ['Date_Of_Nomination', 'Project_Sponsor', 'Project_Sponsor_Approved', 'Project_Sponsor_Reason', 'Project_Sponsor_Date', 'Project_Sponsor_Time', 'Line_Manager', 'Line_Manager_Approved', 'Line_Manager_Reason', 'Line_Manager_Date', 'Line_Manager_Time', 'Exco2', 'Exco2_Approved', 'Exco2_Reason', 'Exco2_Date', 'Exco2_Time', 'HRBP', 'HRBP_Approved', 'HRBP_Reason', 'HRBP_Date', 'HRBP_Time'])
      // ExportToCSV.createCSV(Object.values(cloneItems), 'VE_Awards_Nominations')
      })
      .catch(error => {
        console.error('Error:', error);
        // Handle the error if needed
      });
    },
    showHideFilters: function () {
      if (this.showHideFilterText === '<i class="fas fa-angle-up"></i>') {
        this.showHideFilterText = '<i class="fas fa-angle-down"></i>'
      } else {
        this.showHideFilterText = '<i class="fas fa-angle-up"></i>'
      }
    },
    filterByGraduatedNominations: function () {
      if (this.graduatedNominationsCheck) {
        this.nominationCategorySelect = 45
      } else {
        this.nominationCategorySelect = '-- All --'
      }
      this.loadNominations()
    },
    generateSearchQuery: function () {
      let ideaCatFilter = ''
      let communityFilter = ''
      // let authorFilter = ''
      if (this.nominationCategorySelect !== '-- All --') {
        ideaCatFilter = '&nomination_event_category=' + this.nominationCategorySelect
      }
      if (this.communityCategorySelect !== '-- All --') {
        communityFilter = '&community_categories=' + this.communityCategorySelect
      }
      // if (this.ideaAuthorFilter !== '') {
      //   authorFilter = this.getAuthorSearchQuery()
      // }
      return '?_embed' + ideaCatFilter + communityFilter // + authorFilter
    },
    totalLoadNominations: async function () {
      this.totalNominations = []    
      let currentPage = 1
      const perPageVal = 'custom_per_page=250'

      while (true) {
        try {
          const response = await WordpressRestAPI.getViewContent('nomination' + this.generateSearchQuery() + '&page=' + currentPage + '&' + perPageVal)

          this.totalNominations.push(...response.data);
          console.log('Total Nominations:', this.totalNominations.length);

          if (response.data.length < 250) {
            break;
          }
          currentPage++;
        } catch (e) {
          this.contentLoadError = 'Oops! We had a problem loading nominations. Please try again later.';
          console.error(e);
          break; // Exit the loop on error
        }
      }
    },
    loadNominations: function () {
      this.contentReady = false
      console.log('nomination-> ' + this.generateSearchQuery() + '&page=' + this.currentPage + '&per_page=' + this.itemsPerPage)
      let perPageVal = 'per_page=' + this.itemsPerPage
      if (this.itemsPerPage > 100)
        perPageVal = 'custom_per_page=' + this.itemsPerPage
      WordpressRestAPI.getViewContent('nomination' + this.generateSearchQuery() + '&page=' + this.currentPage + '&' + perPageVal)
        .then(response => {
          this.totalPosts = parseInt(response.headers['x-wp-total'])
          this.nominations = response.data
          this.unfilteredNominations = response.data
          this.contentReady = true
        })
        .catch(e => {
          this.contentLoadError = 'Oops! We had a problem loading nominations. Please try again later.'
          console.error(e)
          this.contentReady = true
        })
    },
    filterByNominee: function () {
      this.nominations = this.unfilteredNominations
      var self = this
      if (this.nomineeFilter !== '' && this.nomineeFilterButton === '+') {
        this.nominations = this.nominations.filter(x => x.nominee_name[0].toLowerCase().indexOf(self.nomineeFilter.toLowerCase()) > -1)
      }
      if (this.nomineeFilterButton === '+') {
        this.nomineeFilterButton = 'x'
      } else {
        this.nomineeFilterButton = '+'
        this.nomineeFilter = ''
      }
    },
    filterByNominator: function () {
      this.nominations = this.unfilteredNominations
      if (this.nominatorFilter !== '' && this.nominatorFilterButton === '+') {
        this.nominations = this.nominations.filter(x => x._embedded.author[0].name.toLowerCase().indexOf(this.nominatorFilter.toLowerCase()) > -1)
      }
      if (this.nominatorFilterButton === '+') {
        this.nominatorFilterButton = 'x'
      } else {
        this.nominatorFilterButton = '+'
        this.nominatorFilter = ''
      }
    },
    filterByStatus: function (status) {
      this.nominations = this.unfilteredNominations
      if (status !== 'All') {
        this.nominations = this.nominations.filter(x => x.nomination_approve_decline[0] === status)
      }
    }
  },
  watch: {
    'currentPage' (newDetails, oldDetails) {
      this.loadNominations()
    }
  }
}
</script>

<style lang="less">
  .showHideBtn {
    padding: 4px 8px;
  }
</style>


// WEBPACK FOOTER //
// src/components/routes/ReportVEAwards.vue